import React from 'react'
import Confirm from 'views/confirm/confirm'
import { connect } from 'react-redux'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'

import myLibraryActions from 'redux/actions/my_library_actions'
import { localize } from 'helpers/translator'

const MyLibraryFeatureDowngrade = props => (
	<Confirm
		alertTitle={localize('feature_downgrade_title')}
		btTwo={localize('feature_downgrade_button')}
		alertMessage={localize('feature_downgrade_message')}
		actionTwo={props.actions.closeFeatureDowngradeAccount}
		closeAction={props.actions.closeFeatureDowngradeAccount}
	/>
)

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		closeFeatureDowngradeAccount: myLibraryActions.closeFeatureDowngradeAccount,
	}, dispatch)
}

export default connect(null, mapDispatchToProps)(MyLibraryFeatureDowngrade)

export { MyLibraryFeatureDowngrade }
